import LocalTime from 'local-time';

LocalTime.config.i18n["nl"] = {
  date: {
    dayNames: [ 'zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag' ],
    monthNames: [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus',
                  'september', 'oktober', 'november', 'december' ]
  }
};
